import { PermissionsEnum } from '@/auth/interfaces';

export const RELATED_PERMISSIONS_ZONE = [
  PermissionsEnum.api_view_pais,
  PermissionsEnum.api_view_provincia,
  PermissionsEnum.api_view_ciudad,
  PermissionsEnum.api_view_parroquia,
];
